/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateTriggerRequestDto,
  ListTriggersResponseDto,
  TriggerResponseDto,
  UpdateTriggerRequestDto,
} from '../models/index';
import {
    CreateTriggerRequestDtoFromJSON,
    CreateTriggerRequestDtoToJSON,
    ListTriggersResponseDtoFromJSON,
    ListTriggersResponseDtoToJSON,
    TriggerResponseDtoFromJSON,
    TriggerResponseDtoToJSON,
    UpdateTriggerRequestDtoFromJSON,
    UpdateTriggerRequestDtoToJSON,
} from '../models/index';

export interface TriggerControllerCreateRequest {
    createTriggerRequestDto: CreateTriggerRequestDto;
}

export interface TriggerControllerDeleteRequest {
    id: string;
}

export interface TriggerControllerFindByIdRequest {
    id: string;
}

export interface TriggerControllerUpdateRequest {
    id: string;
    updateTriggerRequestDto: UpdateTriggerRequestDto;
}

/**
 * 
 */
export class PreventiveMaintenanceTriggersApi extends runtime.BaseAPI {

    /**
     */
    async triggerControllerCreateRaw(requestParameters: TriggerControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TriggerResponseDto>> {
        if (requestParameters['createTriggerRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createTriggerRequestDto',
                'Required parameter "createTriggerRequestDto" was null or undefined when calling triggerControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/triggers`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTriggerRequestDtoToJSON(requestParameters['createTriggerRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TriggerResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async triggerControllerCreate(requestParameters: TriggerControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TriggerResponseDto> {
        const response = await this.triggerControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async triggerControllerDeleteRaw(requestParameters: TriggerControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling triggerControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/triggers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async triggerControllerDelete(requestParameters: TriggerControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.triggerControllerDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async triggerControllerFindAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListTriggersResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/triggers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListTriggersResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async triggerControllerFindAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListTriggersResponseDto> {
        const response = await this.triggerControllerFindAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async triggerControllerFindByIdRaw(requestParameters: TriggerControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TriggerResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling triggerControllerFindById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/triggers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TriggerResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async triggerControllerFindById(requestParameters: TriggerControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TriggerResponseDto> {
        const response = await this.triggerControllerFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async triggerControllerUpdateRaw(requestParameters: TriggerControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TriggerResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling triggerControllerUpdate().'
            );
        }

        if (requestParameters['updateTriggerRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateTriggerRequestDto',
                'Required parameter "updateTriggerRequestDto" was null or undefined when calling triggerControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/triggers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTriggerRequestDtoToJSON(requestParameters['updateTriggerRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TriggerResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async triggerControllerUpdate(requestParameters: TriggerControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TriggerResponseDto> {
        const response = await this.triggerControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
